import chevronUp from "assets/icons/chevron-up.svg";
import chevronDown from "assets/icons/chevron-down.svg";

const AccordionItem = ({
  title,
  children,
  isOpen,
  onClick,
  className,
  imgClick,
}) => {
  return (
    <div className={`accordion-wrapper ${className}`}>
      <button className="accordion-button" onClick={onClick}>
        <span className="accordion-title">{title}</span>
        {isOpen ? (
          <img
            onClick={imgClick}
            className="flex-shrink-0"
            src={chevronUp}
            alt="Collapse"
            size={20}
          />
        ) : (
          <img
            onClick={imgClick}
            className="flex-shrink-0"
            src={chevronDown}
            alt="Expand"
            size={20}
          />
        )}
      </button>

      {isOpen && <div className="accordion-content-wrapper">{children}</div>}
    </div>
  );
};

export default AccordionItem;
